import React, { useState, useContext } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { UserContext } from "context/user";
import { shareFarm } from "api/Farm";
import CustomModal from "components/Modal";
import Button from "components/Button";
import "./index.scss";

const ShareFarm = ({ isOpen, onClose, selectedFarms, farm, view }) => {
  const { token } = useContext(UserContext);
  const [items, setItems] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [userEmail, setUserEmail] = useState([]);
  const [userRole, setUserRole] = useState("editor");

  const handleClose = () => {
    setItems([]);
    onClose();
  };
  // invite collaborators to user farms
  const confirmInvite = async () => {
    let farmsToShare;
    let emails;
    // if user have multiple farms selected
    // selectedFarms will be passed on the params.
    if (selectedFarms && selectedFarms.length > 1) {
      farmsToShare = selectedFarms;
    }

    // if user farm is selected.
    // selectedFarms is null and the current farm is passed on the params.
    if (selectedFarms.length === 0 || selectedFarms === 0) {
      farmsToShare = farm && farm?.id ? [farm.id] : [farm.farm_id];
    }

    // if the user has multiple emails supplied.
    // emails and roles are formatted based on BE accepted params.
    if (userEmail) {
      if (userEmail.length >= 1) {
        emails = userEmail.map((email) => {
          return { email, permission: userRole.toLowerCase() };
        });
      }
    }

    // contains the data based on the format of BE endpoint.
    const data = {
      data: {
        farm_ids: farmsToShare,
        account_permission: emails,
      },
    };

    try {
      await shareFarm(data, token);
      toast.success("Farms shared successfully");
      if (view === "farms") {
        window.location.reload();
      }
      handleClose();
    } catch (e) {
      if (e?.response.status === 401) {
        toast.error(e?.response?.data?.detail?.message);
      }
      if (e?.response?.status === 422) {
        toast.error(e.response.data.detail[0].msg);
      }
    }
  };

  const handleInputChange = (evt) => {
    setInputValue(evt.target.value);
  };

  const handleInputKeyDown = (evt) => {
    if (evt.keyCode === 32) {
      const { value } = evt.target;
      if (value.trim()) {
        setItems([...items, value]);
        setInputValue("");
        setUserEmail([...items, value]);
      } else {
        toast.error("Email Address is invalid");
        setInputValue("");
        setUserEmail([]);
      }
    }

    if (items.length && evt.keyCode === 8 && !inputValue.length) {
      setItems(items.slice(0, items.length - 1));
      setUserEmail(items.slice(0, items.length - 1));
    }
  };

  const handleOnBlur = (evt) => {
    const { value } = evt.target;
    if (value.trim()) {
      setItems([...items, value]);
      setInputValue("");
      setUserEmail([...items, value]);
    }

    if (items.length && evt.keyCode === 8 && !inputValue.length) {
      setItems(items.slice(0, items.length - 1));
      setUserEmail(items.slice(0, items.length - 1));
    }
  };

  const handleRemoveItem = (index) => {
    return () => {
      const newItems = items.filter((item, i) => i !== index);
      setItems([newItems]);
      if (newItems.length === 0) {
        setUserEmail([]);
        setItems([]);
      } else {
        setUserEmail([newItems]);
      }
    };
  };

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={handleClose}
      onClose={handleClose}
      size="medium"
    >
      <div className="share-farm">
        <div className="header">
          <h1 className="title">Add People to Collaborate</h1>
          <p className="text">
            Invite people to join with you and collaborate in this farm.
          </p>
        </div>
        <div className="tag-container">
          <div className="tag">
            <ul className="email-container">
              {items?.map((item, i) => (
                <li
                  onClick={handleRemoveItem(i)}
                  className="email-item"
                  aria-hidden
                >
                  {item}
                  <span className="icon-close-16" />
                </li>
              ))}
              <input
                className="tag-input"
                value={inputValue}
                onChange={handleInputChange}
                onKeyDown={handleInputKeyDown}
                onBlur={handleOnBlur}
                placeholder="Enter email address"
              />
            </ul>
          </div>
        </div>
        <p className="email-note">
          Add multiple email addresses by using spaces
        </p>
        <div className="invite-field">
          <select
            name="role"
            className="select-input"
            onChange={(e) => setUserRole(e.target.value)}
          >
            <option value="editor">Invite as an editor</option>
            <option value="viewer">Invite as a viewer</option>
          </select>
          <Button
            type="solid"
            color="blue"
            label="Share"
            block
            onClick={confirmInvite}
          />
        </div>
      </div>
    </CustomModal>
  );
};

ShareFarm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  selectedFarms: PropTypes.shape({
    length: PropTypes.number.isRequired,
  }).isRequired,
  farm: PropTypes.shape({
    farm_id: PropTypes.number.isRequired,
    farm_name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
  }).isRequired,
  view: PropTypes.string.isRequired,
};

export default ShareFarm;
